import React from 'react';
import styled from 'styled-components/macro';
import { Body, Flex } from '@cognite/cogs.js';
import { formatDateRecentTime } from 'utils/misc';
import { ConsistencySchemaFilterView } from '../types';

type CollectionInfoPanelProps = {
  collection: {
    description: string | null;
    createdAt: string | null;
    labels?: string[];
  };
  schemaFilters: ConsistencySchemaFilterView[];
};

export const CollectionInfoPanel = ({
  collection,
  schemaFilters,
}: CollectionInfoPanelProps) => {
  const uniqueSchemaIds = Array.from(
    new Set(schemaFilters.map((sf) => sf.schemaCollectionName))
  );

  return (
    <StyledWrapper direction="column" gap={8}>
      <Body size="small">
        <FieldLabel as="span">Description:</FieldLabel>{' '}
        {collection.description || 'No description provided'}
      </Body>
      <Body size="small">
        <FieldLabel as="span">Schemas:</FieldLabel>{' '}
        {uniqueSchemaIds.length > 0
          ? uniqueSchemaIds.join(', ')
          : 'No schemas selected'}
      </Body>
      <Body size="small">
        <FieldLabel as="span">Created:</FieldLabel>{' '}
        {collection.createdAt
          ? formatDateRecentTime(collection.createdAt)
          : 'Unknown'}
      </Body>
      {collection.labels && collection.labels.length > 0 && (
        <Body size="small">
          <FieldLabel as="span">Labels:</FieldLabel>{' '}
          {collection.labels.join(', ')}
        </Body>
      )}
    </StyledWrapper>
  );
};

const StyledWrapper = styled(Flex)`
  padding: 1rem 2rem;
  background: var(--cogs-greyscale-grey1);
  border-bottom: 1px solid var(--cogs-bg-control--disabled);
`;

const FieldLabel = styled(Body)`
  font-weight: 600;
`;
